module.exports = __webpack_public_path__ + "img/dacenterQrcode.f81a4d9a.jpeg";